var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "loading-header" },
      [
        _c("CompassSkeleton", {
          staticClass: "skeleton-title",
          attrs: { size: "x-large" }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "loading-content" },
      [
        _c(
          "div",
          { staticClass: "skeleton-filter" },
          [_c("CompassSkeleton", { attrs: { size: "x-large" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "skeleton-row-head" },
          [_c("CompassSkeleton")],
          1
        ),
        _vm._v(" "),
        _vm._l(24, function(_, index) {
          return _c(
            "div",
            { key: index, staticClass: "skeleton-row-body" },
            [_c("CompassSkeleton")],
            1
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }